import { useEditor, EditorContent } from '@tiptap/react'
import { useEffect, memo } from 'react'
import { getTiptapExtensions, RENDERER_PROPS, SHARED_EDITOR_OPTIONS } from './RichTextEditor.constants'

interface RichTextRendererProps {
    content: string
    className?: string
}

/**
 * RichTextRenderer Component
 * 
 * Safely renders HTML content by processing it through Tiptap's schema.
 * This ensures that only allowed tags and attributes are rendered, 
 * effectively sanitizing the input.
 */
const RichTextRendererComponent = ({ content, className = '' }: RichTextRendererProps) => {
    const editor = useEditor({
        ...SHARED_EDITOR_OPTIONS,
        extensions: getTiptapExtensions(),
        content: content,
        editable: false,
        editorProps: RENDERER_PROPS,
    })

    // Update content if it changes
    useEffect(() => {
        if (editor && content !== editor.getHTML()) {
            editor.commands.setContent(content)
        }
    }, [content, editor])

    if (!editor) {
        return null
    }

    return (
        <div className={`rich-text-renderer ${className}`}>
            <EditorContent editor={editor} />
        </div>
    )
}

// Memoize the component to prevent unnecessary re-renders in lists
export const RichTextRenderer = memo(RichTextRendererComponent)
